module.exports = __webpack_public_path__ + "static/media/SpenLeaf-1.280efbdd.webp";